import script from "./InviteUsersToWorkspaceModal.vue?vue&type=script&setup=true&lang=js"
export * from "./InviteUsersToWorkspaceModal.vue?vue&type=script&setup=true&lang=js"

import "./InviteUsersToWorkspaceModal.vue?vue&type=style&index=0&id=5e8a7444&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5e8a7444"]])

export default __exports__